import { component } from 'picoapp';

export default component((node) => {
  /**
   * Data + elements
   */
  const colorList = node.querySelector('.js-colorList');

  const config = JSON.parse(node.dataset.config);

  /**
   * Functions
   */
  const initSwatches = () => {
    const lists = window.theme.swatches;

    let markup = `${config.colors.slice(0, config.colorLimit).map((color) => {
      const listName = Object.keys(lists).find((key) => Object.keys(lists[key]).includes(color));

      // If the swatch is a color, we simply color the <li>,
      // and if it's a pattern, we put an <img> inside
      return `<li class="product-item__colors__item ${color === 'white' ? 'border border-grey-30' : ''}" ${listName === 'colors' ? `style="background-color: ${lists[listName][color]};"` : ''} data-color="${color}">
          ${listName === 'patterns' ? `<img src="${lists[listName][color]}" alt="${color}" class="lazyload">` : ''}
        </li>`;
    }).join('')}`;

    if (config.colors.length > config.colorLimit) {
      markup += `<li>+${config.colors.length - config.colorLimit}</li>`;
    }

    colorList.innerHTML = markup;
  };

  const init = () => {
    if (colorList) initSwatches();
  };

  /**
   * Init
   */
  init();
});
